/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCredsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {GetCredsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const getCreds = (request:GetCredsRequest, options?: CashRequestOptions) => post<GetCredsRequest, GetCredsResponse>("/2.0/cash/get-creds", request, {...options, rejectOnError: true })